module.exports = __webpack_public_path__ + "img/icon-hot-active.676855d.webp";